<template>
  <div class="media-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5">
        <el-input v-model="form.bloggerName" size="small" placeholder="博主账号名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5">
        <el-select v-model="form.mediaType" size="small" placeholder="平台" class="w-100" clearable>
          <el-option v-for="(label, value) in mediaConfig.getConfigList('media_ch')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <p class="table-count">合作博主账号总数：{{ page.total }}条</p>
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="博主账号名称">
          <template slot-scope="scope">
            <div class="account-wrap">
              <div class="avatar-out">
                <div class="avatar-in">
                  <div class="img-wrap" v-if="scope.row.avatar">
                    <!--有头像-->
                    <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                    <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                  </div>
                  <div class="img-wrap" v-else>
                    <img src="/img/media/weibo_default.png" class="avatar">
                  </div>
                </div>
              </div>
              <div class="info-wrap">
                <el-tooltip :content="scope.row.name" placement="bottom" effect="light">
                  <div class="nickname"><span>{{ scope.row.name }}</span></div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台" align="center" prop="mediaType">
          <template slot-scope="scope">
            {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="relationContractNum">
          <template slot="header" slot-scope="scope">
            <div style=" display: flex;align-items: center;  justify-content: center;">
              关联合同数 <el-tooltip class="item" effect="light" content="博主关联合同数量总和(包含关闭的合同)" placement="bottom">
                <i class="iconfont icon-tishi" style="color:#303133; margin-left: 10px;font-size:12px"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.relationContractNum }}
          </template>
        </el-table-column>
        <el-table-column label="总执行金额" align="center" prop="executeMoneyAll">
          <template slot="header" slot-scope="scope">
            <div style=" display: flex;align-items: center;  justify-content: center;">
              总执行金额 <el-tooltip class="item" effect="light" content="博主所有投放记录的执行金额总额（排除投放失败的）" placement="bottom">
                <i class="iconfont icon-tishi" style="color:#303133; margin-left: 10px;font-size:12px"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ readableNum(scope.row.executeMoneyAll) }}
          </template>
        </el-table-column>
        <el-table-column label="博主其他成本" align="center" prop="otherCostAll">
          <template slot="header" slot-scope="scope">
            <div style=" display: flex;align-items: center;  justify-content: center;">
              博主其他成本 <el-tooltip class="item" effect="light" content="博主所有投放记录的其他成本总额（排除投放失败的）" placement="bottom">
                <i class="iconfont icon-tishi" style="color:#303133; margin-left: 10px;font-size:12px"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ readableNum(scope.row.otherCostAll) }}
          </template>
        </el-table-column>
        <el-table-column label="分成总收入" align="center" prop="shareMoneyAll">
          <template slot="header" slot-scope="scope">
            <div style=" display: flex;align-items: center;  justify-content: center;">
              分成总收入 <el-tooltip class="item" effect="light" content="博主所有投放记录的分成基数金额总额（排除投放失败的）" placement="bottom">
                <i class="iconfont icon-tishi" style="color:#303133; margin-left: 10px;font-size:12px"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ readableNum(scope.row.shareMoneyAll) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toRelateContract(scope.row.mediaType, scope.row.mediaId)">查看关联合同</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
    </div>
  </div>
</template>

<script>
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { listAllBlogger } from "@/api/business/contract";
export default {
  props: ["linkTo"],
  data() {
    return {
      mediaConfig: mediaConfig,
      form: {
        bloggerName: "",
        mediaType: "",
      },
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    onReset() {
      this.form = {
        bloggerName: "",
        mediaType: "",
      };
      this.onSearch();
    },
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      console.log("queryObj", queryObj);
      this.tableLoading = true;
      listAllBlogger(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    toRelateContract(mediaType, mediaId) {
      let router = this.$router.resolve({
        path: "/business/contract/media-related",
        query: {
          mtype: mediaType,
          mid: mediaId,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    linkTo(newVal, oldVal) {},
  },
};
</script>

<style lang="scss" scoped>
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count {
  margin: 15px 0 10px;
}
</style>